module.exports = __webpack_public_path__ + "media/signup/google-539d5f90.png";